import { Suspense, useEffect, useState, FC } from 'react';
import { shallowEqual } from 'react-redux';
import { useAppSelector } from 'store/store';
import { LanguageProvider } from './hooks/LanguageProvider';
import { LoadingPage } from './common/loading/LoadingPage';
import { AppRoutes } from 'routes';

const App: FC = () => {
    const [showServiceLoader, setShowServiceLoader] = useState<boolean>(true);
    const { isLoading } = useAppSelector(state => ({
        isLoading: state.applicationContext.isLoading,
    }), shallowEqual);

    useEffect(() => {
        const timer = setTimeout(() => setShowServiceLoader(false), 1000);
        return () => clearTimeout(timer);
    }, []);

    return <Suspense fallback={<LoadingPage />}>
        {showServiceLoader && <LoadingPage />}
        {!showServiceLoader && !isLoading && <>
            <LanguageProvider />
            <AppRoutes />
        </>}
    </Suspense>;
};

export default App;
